export default __webpack_public_path__ + "static/media/star.fdae0c13.svg";